var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("span", { staticClass: "text-subtitle-1" }, [
      _vm._v(_vm._s(_vm.$t("botFormEdit.fileUpload.allowedFileTypes"))),
    ]),
    _c(
      "p",
      { staticClass: "text-subtitle-2" },
      [
        _c("v-select", {
          attrs: {
            items: _vm.mimeTypes,
            "item-text": "title",
            "item-value": "mime",
            multiple: "",
            chips: "",
            label: _vm.$t("botFormEdit.fileUpload.allowedFileTypes"),
            hint: _vm.$t("botFormEdit.fileUpload.allowedFileTypesDescription"),
            "persistent-hint": "",
            outlined: "",
          },
          on: {
            change: _vm.allowedTypesChanged,
            "hook:mounted": _vm.initMimeTypes,
          },
          model: {
            value: _vm.allowedTypes,
            callback: function ($$v) {
              _vm.allowedTypes = $$v
            },
            expression: "allowedTypes",
          },
        }),
      ],
      1
    ),
    _vm.isAdmin
      ? _c("div", { staticClass: "d-flex gap-4 flex-wrap" }, [
          _c(
            "div",
            {
              staticClass:
                "items-center align-center moin-admin-box w-fit pl-4 pr-1 py-1",
              staticStyle: { "min-height": "64px" },
            },
            [
              _c("label", { staticClass: "mr-3" }, [
                _vm._v(
                  _vm._s(_vm.$t("botFormEdit.fileUpload.maxFilesTemplate"))
                ),
              ]),
              _c("v-slider", {
                staticStyle: { "max-width": "400px", "min-width": "150px" },
                attrs: {
                  label: `${_vm.$t("botFormEdit.fileUpload.maxFilesLabel")}: ${
                    _vm.maxFiles
                  }`,
                  min: _vm.fileCountLimits.min,
                  max: _vm.fileCountLimits.max,
                  "thumb-label": "",
                  "hide-details": "",
                },
                on: { change: _vm.setMaxFileCount },
                model: {
                  value: _vm.maxFiles,
                  callback: function ($$v) {
                    _vm.maxFiles = $$v
                  },
                  expression: "maxFiles",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass:
                "items-center align-center moin-admin-box w-fit pl-4 pr-1 py-1",
              staticStyle: { "min-height": "64px" },
            },
            [
              _c("label", { staticClass: "mr-3" }, [
                _vm._v(
                  _vm._s(_vm.$t("botFormEdit.fileUpload.maxFileSizeTemplate"))
                ),
              ]),
              _c("v-text-field", {
                attrs: {
                  value: _vm.maxFilesizeMB,
                  type: "number",
                  step: "1",
                  min: _vm.fileSizeLimits.min,
                  max: _vm.fileSizeLimits.max,
                  suffix: "MB",
                  "hide-details": "",
                  dense: "",
                },
                on: { input: _vm.setMaxFileSizeMB },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }